import { adminFetch } from './adminFetch';

/**
 * 変わった顧客・新しく登録する顧客だけをサーバーに送って保存する（id で既存と差し替え）。
 * 顧客一覧は数万件あり、全件を送るとPHPの送信上限(post_max_size)を超えるため、全件は送らない。
 * 取り込みで件数が多いときは1000件ずつに分けて送る。全部保存できたら true。
 */
export const saveChangedCustomers = async (changed) => {
  for (let i = 0; i < changed.length; i += 1000) {
    const res = await adminFetch('/api/admin-crm.php?action=save_many', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customers: changed.slice(i, i + 1000) }),
    });
    const result = await res.json();
    if (!result.success) return false;
  }
  return true;
};

/** 画面に持っている顧客一覧に、保存した顧客を反映する（id が同じなら差し替え、なければ末尾に追加）。 */
export const mergeCustomers = (prev, changed) => {
  const byId = new Map(changed.map((c) => [c.id, c]));
  const next = prev.map((c) => (byId.has(c.id) ? byId.get(c.id) : c));
  const ids = new Set(prev.map((c) => c.id));
  return [...next, ...changed.filter((c) => !ids.has(c.id))];
};
